var map = {
	"./404.json": "3f19",
	"./addFile.json": "0751",
	"./calendar.json": "ff10",
	"./clipboard.json": "857f",
	"./file.json": "8f8b",
	"./loader.json": "d520",
	"./noData.json": "0014",
	"./notifySleep.json": "fb3f",
	"./search.json": "34a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e8e0";